/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import pageHeaderCss from "components/common/PageHeader/index.css";
import { rowGap24Css } from "assets/css/gaps.css";
import PageSection from "components/PageSection";
import PhaseRuleBreadcrumbs from "./PhaseRuleBreadcrumbs";
import { buttonCss, pageHeaderContainerCss } from "./index.css";

export default function Layout({ children, handleNewRule }) {
  return (
    <div className="container">
      <div className="flex-column" css={rowGap24Css}>
        <PhaseRuleBreadcrumbs />
        <PageSection css={pageHeaderContainerCss}>
          <h1 css={pageHeaderCss.header} className="main-title">
            Phase Variable Rules
          </h1>
        </PageSection>

        {children}
        <button type="button" onClick={handleNewRule} css={buttonCss}>
          New Rule
        </button>
      </div>
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  handleNewRule: PropTypes.func.isRequired,
};
